module.exports = __webpack_public_path__ + "img/9631_springgreen.b34ea9cf.jpg";